module.exports = __webpack_public_path__ + "img/cart.7cf3017f.svg";